/* bs-pdp-reviews.js
   PDP Reviews — Mobile Variant C "Full Breakdown + Filter" (Paper 6ZC-0)

   The Judge.me review widget's markup is owned by the app, so the jobs CSS
   alone cannot do are done here:

     1. relocate .jdgm-widget-actions-wrapper (WRITE A REVIEW / ASK A
        QUESTION) out of the summary card and below the review list, which
        is the whole point of Variant C;
     2. lift the "4.87 out of 5" link out of the star row so it can be the
        big display numeral beside the stars;
     3. fold VERIFIED (and a real reviewer location) in beside the author
        name, so a long display name cannot widen the review grid;
     4. stamp data attributes the stylesheet reads with attr() — the review
        count, the bare average, the blank location wrappers, and whether a
        star filter is currently applied;
     5. make the whole histogram row a filter target, not just the small
        star cluster inside it.

   EVERY DOM move is mobile-only and is reversed above 767px, because the
   desktop build (the "pdp reviews v2/v3/v4" blocks in theme.css) depends on
   the app's original nesting. Each element's original parent and next
   sibling are recorded before it is first moved, so the restore is exact.

   Everything is idempotent and re-applied through a MutationObserver,
   because Judge.me re-renders the widget on sort, filter and pagination.
   Every step is individually guarded: a product with no reviews renders a
   different block and simply matches nothing here.  */
(function () {
  'use strict';

  var ROOT = '.jdgm-rev-widg';
  var MOBILE = '(max-width: 767px)';

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia(MOBILE).matches);
  }

  // Move el into target, remembering where the app originally put it so the
  // desktop layout can be handed back untouched.
  function place(el, target) {
    if (!el || !target || el === target || el.contains(target)) return;
    if (!el.__bsHome && el.parentElement) {
      el.__bsHome = { parent: el.parentElement, next: el.nextElementSibling };
    }
    if (el.parentElement === target) return;
    target.appendChild(el);
  }

  function restore(el) {
    var home = el && el.__bsHome;
    if (!home || !home.parent || !home.parent.isConnected) return;
    if (el.parentElement === home.parent) return;
    if (home.next && home.next.parentElement === home.parent) {
      home.parent.insertBefore(el, home.next);
    } else {
      home.parent.appendChild(el);
    }
  }

  function placeOrRestore(el, target, mobile) {
    if (!el) return;
    if (mobile) place(el, target);
    else restore(el);
  }

  function layout(widg, mobile) {
    // 1. the two CTAs move below the review list
    placeOrRestore(widg.querySelector('.jdgm-widget-actions-wrapper'), widg, mobile);

    // 2. the average numeral becomes a sibling of the star row
    placeOrRestore(
      widg.querySelector('.jdgm-rev-widg__summary-average'),
      widg.querySelector('.jdgm-rev-widg__summary-inner'),
      mobile
    );

    // 3. VERIFIED joins the author name on its own line
    var badges = widg.querySelectorAll('.jdgm-rev__buyer-badge-wrapper');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      if (!badge.firstElementChild) continue;              // nothing to show
      var rev = badge.closest ? badge.closest('.jdgm-rev') : null;
      placeOrRestore(badge, rev && rev.querySelector('.jdgm-rev__author-wrapper'), mobile);
    }

    // 4. reviewer location: almost always whitespace-only, which :empty does
    //    not match, so it was claiming a 16px grid row under every review.
    var extras = widg.querySelectorAll('.jdgm-row-extra');
    for (var j = 0; j < extras.length; j++) {
      var extra = extras[j];
      var blank = !(extra.textContent || '').trim() && !extra.querySelector('img, svg');
      if (blank) {
        if (extra.getAttribute('data-bs-blank') !== '1') extra.setAttribute('data-bs-blank', '1');
        restore(extra);
        continue;
      }
      extra.removeAttribute('data-bs-blank');
      var rev2 = extra.closest ? extra.closest('.jdgm-rev') : null;
      placeOrRestore(extra, rev2 && rev2.querySelector('.jdgm-rev__author-wrapper'), mobile);
    }
  }

  function stampCount(widg) {
    var row = widg.querySelector('.jdgm-row-actions');
    if (!row) return;
    var n = widg.getAttribute('data-number-of-reviews');
    if (!n) return;
    if (row.getAttribute('data-bs-count') !== n) row.setAttribute('data-bs-count', n);
  }

  function stampAverage(widg) {
    var link = widg.querySelector('.jdgm-rev-widg__summary-average a, .jdgm-rev-widg__summary-average .jdgm-link');
    if (!link) return;
    var avg = widg.getAttribute('data-average-rating');
    if (!avg) return;
    if (link.getAttribute('data-bs-avg') !== avg) link.setAttribute('data-bs-avg', avg);
  }

  // Judge.me ships the "See all reviews" reset row in the histogram at all
  // times; it only means anything while a star filter is on. Track that here
  // so the stylesheet can hide it the rest of the time.
  function markFiltered(widg) {
    var rows = widg.querySelectorAll('.jdgm-histogram__row[data-rating]');
    var on = false;
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (r.classList.contains('jdgm-histogram__row--active') ||
          r.classList.contains('jdgm--active') ||
          r.classList.contains('jdgm-active') ||
          r.getAttribute('aria-pressed') === 'true') { on = true; break; }
    }
    if (!on && widg.getAttribute('data-bs-filter-click') === '1') on = true;
    if (on) widg.setAttribute('data-bs-filtered', '1');
    else widg.removeAttribute('data-bs-filtered');
  }

  // Judge.me only binds the click handler to .jdgm-histogram__star. Variant C
  // makes the whole row the tap-to-filter target, so forward row taps to it.
  function forwardRowTap(e) {
    if (!e.target || !e.target.closest) return;
    var widg = e.target.closest(ROOT);
    if (e.target.closest('.jdgm-histogram__clear-filter')) {
      if (widg) widg.setAttribute('data-bs-filter-click', '0');
      return;
    }
    var row = e.target.closest('.jdgm-histogram__row[data-rating]');
    if (!row) return;
    if (widg) widg.setAttribute('data-bs-filter-click', '1');
    var star = row.querySelector('.jdgm-histogram__star');
    if (!star || e.target === star || star.contains(e.target)) return;
    e.preventDefault();
    star.click();
  }

  function bindHistogram(widg) {
    if (widg.getAttribute('data-bs-histogram-bound') === '1') return;
    widg.setAttribute('data-bs-histogram-bound', '1');
    widg.addEventListener('click', forwardRowTap);
    widg.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      forwardRowTap(e);
    });
  }

  var applying = false;
  function apply() {
    if (applying) return;
    applying = true;
    try {
      var mobile = isMobile();
      var widgets = document.querySelectorAll(ROOT);
      for (var i = 0; i < widgets.length; i++) {
        try {
          layout(widgets[i], mobile);
          stampCount(widgets[i]);
          stampAverage(widgets[i]);
          markFiltered(widgets[i]);
          bindHistogram(widgets[i]);
        } catch (err) { /* one bad widget must not stop the others */ }
      }
    } finally {
      applying = false;
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; apply(); }, 50);
  }

  function watch() {
    apply();
    var host = document.getElementById('judgeme_product_reviews') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    }
    if (window.matchMedia) {
      var mq = window.matchMedia(MOBILE);
      if (mq.addEventListener) mq.addEventListener('change', schedule);
      else if (mq.addListener) mq.addListener(schedule);
    }
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  // the widget is rendered asynchronously by the app's own bundle
  window.addEventListener('load', schedule);
})();
